import { i as isElement } from './instanceOf-f2c9fcdf.js';

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

export { getDocumentElement as g };
//# sourceMappingURL=getDocumentElement-03ce9e66.js.map
